import { ConnectionProfile } from './types'

export const connectionProfiles: ConnectionProfile[] = [
  // Authors
  {
    id: 'auth-1',
    name: 'Elena Richards',
    image:
      'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    role: 'Mystery Author',
    variant: 'author',
    vendorType: 'authors',
    rating: 4.9,
    reviewCount: 1240,
    specialties: ['Mystery', 'Thriller', 'Suspense'],
    location: 'New York, NY',
    verified: true,
    profileUrl: '/author/elena-richards',
    bookCount: 12,
    bio: 'Bestselling author of the Echo Series. Always looking for cross-promotion opportunities.',
    genres: ['Mystery', 'Thriller'],
    availabilityLabel: 'Open to Collabs',
    joinedDate: '2023-01-15',
    willWorkOn: ['Mystery', 'Thriller', 'Suspense', 'Crime'],
    wontWorkOn: ['Horror', 'Erotica'],
    contentComfort: { maxSpice: 2, maxDarkness: 3 },
  },
  {
    id: 'auth-2',
    name: 'Marcus Chen',
    image:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    role: 'Fantasy Author',
    variant: 'author',
    vendorType: 'authors',
    rating: 4.7,
    reviewCount: 850,
    specialties: ['Epic Fantasy', 'World Building', 'Magic Systems'],
    location: 'Seattle, WA',
    verified: true,
    profileUrl: '/author/marcus-chen',
    bookCount: 8,
    bio: 'Hugo-nominated fantasy writer. Seeking beta readers for next project.',
    genres: ['Fantasy'],
    availabilityLabel: 'Beta Readers Needed',
    joinedDate: '2023-03-20',
    willWorkOn: ['Fantasy', 'Epic Fantasy', 'Sci-Fi'],
    wontWorkOn: ['Romance', 'Contemporary'],
    contentComfort: { maxSpice: 1, maxDarkness: 2 },
  },
  {
    id: 'auth-3',
    name: 'Sarah Jenkins',
    image:
      'https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    role: 'Romance Author',
    variant: 'author',
    vendorType: 'authors',
    rating: 4.5,
    reviewCount: 320,
    specialties: ['Contemporary Romance', 'RomCom', "Women's Fiction"],
    location: 'Austin, TX',
    verified: false,
    profileUrl: '/author/sarah-jenkins',
    bookCount: 5,
    bio: 'Writing love stories that make you laugh and cry. Open to newsletter swaps.',
    genres: ['Romance'],
    availabilityLabel: 'Newsletter Swaps',
    joinedDate: '2023-10-05',
    willWorkOn: ['Romance', 'Contemporary Romance', 'RomCom'],
    wontWorkOn: ['Dark Romance', 'Thriller'],
    contentComfort: { maxSpice: 3, maxDarkness: 1 },
  },

  // Narrators
  {
    id: 'narr-1',
    name: 'Sarah Johnson',
    image:
      'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    role: 'Audiobook Narrator',
    variant: 'narrator',
    vendorType: 'narrators',
    rating: 5.0,
    reviewCount: 320,
    specialties: ['Romance', 'Dual POV', 'Accents'],
    location: 'Los Angeles, CA',
    verified: true,
    profileUrl: '/narrators/sarah-johnson',
    audiobookCount: 150,
    startingPrice: '$250 PFH',
    bio: 'Award-winning narrator with a home studio. Specializing in contemporary romance and mystery.',
    genres: ['Romance', 'Mystery'],
    availabilityLabel: 'Open for Booking',
    joinedDate: '2022-11-10',
    willWorkOn: [
      'Romance',
      'Mystery',
      'Contemporary Romance',
      'Historical Romance',
    ],
    wontWorkOn: ['Horror', 'Erotica'],
    contentComfort: { maxSpice: 4, maxDarkness: 3 },
  },
  {
    id: 'narr-2',
    name: 'Michael Harris',
    image:
      'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    role: 'Voice Actor',
    variant: 'narrator',
    vendorType: 'narrators',
    rating: 4.8,
    reviewCount: 210,
    specialties: ['Sci-Fi', 'Fantasy', 'Deep Voice'],
    location: 'Chicago, IL',
    verified: true,
    profileUrl: '/narrators/michael-harris',
    audiobookCount: 85,
    startingPrice: '$200 PFH',
    bio: 'Bringing epic worlds to life. Experienced in multi-cast productions.',
    genres: ['Sci-Fi', 'Fantasy'],
    availabilityLabel: 'Limited Availability',
    joinedDate: '2023-02-15',
    willWorkOn: ['Sci-Fi', 'Fantasy', 'Space Opera', 'Dystopian'],
    wontWorkOn: ['Romance'],
    contentComfort: { maxSpice: 2, maxDarkness: 4 },
  },
  {
    id: 'narr-3',
    name: 'Emily Davis',
    image:
      'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    role: 'Narrator & Producer',
    variant: 'narrator',
    vendorType: 'narrators',
    rating: 4.9,
    reviewCount: 150,
    specialties: ['Young Adult', 'Fantasy', 'Character Voices'],
    location: 'London, UK',
    verified: true,
    profileUrl: '/narrators/emily-davis',
    audiobookCount: 45,
    startingPrice: '$225 PFH',
    bio: 'Versatile voice actor with a passion for YA fantasy. Full production services available.',
    genres: ['Fantasy', 'Young Adult'],
    availabilityLabel: 'Booking Nov 2023',
    joinedDate: '2023-09-28',
    willWorkOn: ['Young Adult', 'Fantasy', 'Urban Fantasy'],
    wontWorkOn: ['Erotica', 'Dark Romance'],
    contentComfort: { maxSpice: 2, maxDarkness: 3 },
  },

  // Vendors / Merch
  {
    id: 'vend-1',
    name: 'Bookish Candles Co.',
    image:
      'https://images.unsplash.com/photo-1602874801002-53744d8b5c4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    role: 'Merch Vendor',
    variant: 'service',
    vendorType: 'vendors',
    rating: 4.9,
    reviewCount: 1500,
    specialties: ['Soy Candles', 'Custom Scents', 'Wholesale'],
    location: 'Portland, OR',
    verified: true,
    profileUrl: '/vendor/bookish-candles',
    startingPrice: '$15/unit',
    bio: 'Hand-poured soy candles inspired by your favorite fictional worlds. Wholesale available for book boxes.',
    availabilityLabel: 'Wholesale Open',
    joinedDate: '2022-08-01',
    willWorkOn: ['Fantasy', 'Romance', 'Mystery', 'Sci-Fi'],
    wontWorkOn: [],
    contentComfort: { maxSpice: 5, maxDarkness: 5 },
  },
  {
    id: 'vend-2',
    name: 'Literary Apparel',
    image:
      'https://images.unsplash.com/photo-1529374255404-311a2a4f1fd9?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    role: 'Apparel Creator',
    variant: 'service',
    vendorType: 'vendors',
    rating: 4.6,
    reviewCount: 420,
    specialties: ['T-Shirts', 'Hoodies', 'Embroidered'],
    location: 'Austin, TX',
    verified: false,
    profileUrl: '/vendor/literary-apparel',
    startingPrice: '$25/unit',
    bio: 'Cozy apparel for book lovers. Custom designs for author merch stores.',
    availabilityLabel: 'Taking Orders',
    joinedDate: '2023-04-10',
    willWorkOn: ['Romance', 'Fantasy', 'Contemporary'],
    wontWorkOn: [],
    contentComfort: { maxSpice: 5, maxDarkness: 5 },
  },
  {
    id: 'vend-3',
    name: 'Fictional Tea Blends',
    image:
      'https://images.unsplash.com/photo-1594631252845-29fc4cc8cde9?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    role: 'Tea Vendor',
    variant: 'service',
    vendorType: 'vendors',
    rating: 4.8,
    reviewCount: 210,
    specialties: ['Loose Leaf Tea', 'Bookish Blends', 'Gift Sets'],
    location: 'Denver, CO',
    verified: true,
    profileUrl: '/vendor/fictional-tea',
    startingPrice: '$12/bag',
    bio: 'Small batch tea blends inspired by classic literature and modern bestsellers.',
    availabilityLabel: 'Open for Collabs',
    joinedDate: '2023-10-15',
    willWorkOn: ['Historical Fiction', 'Fantasy', 'Romance'],
    wontWorkOn: [],
    contentComfort: { maxSpice: 5, maxDarkness: 5 },
  },

  // Editors
  {
    id: 'edit-1',
    name: "Emma's Editing",
    image:
      'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    role: 'Developmental Editor',
    variant: 'service',
    vendorType: 'editors',
    rating: 4.9,
    reviewCount: 85,
    specialties: ['Romance', 'Fantasy', 'Dev Edit'],
    location: 'Remote',
    verified: true,
    profileUrl: '/services/editing/emma',
    startingPrice: '$0.02/word',
    bio: "Specializing in developmental editing for romance and fantasy novels. Let's fix that plot hole!",
    availabilityLabel: 'Booking for Q3',
    joinedDate: '2023-01-20',
    willWorkOn: [
      'Romance',
      'Fantasy',
      'Contemporary Romance',
      'Paranormal Romance',
    ],
    wontWorkOn: ['Dark Romance', 'Erotica', 'Horror'],
    contentComfort: {
      maxSpice: 3,
      maxDarkness: 2,
      excludeWarnings: ['Violence'],
    },
  },
  {
    id: 'edit-2',
    name: 'Precision Proofing',
    image:
      'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    role: 'Copy Editor',
    variant: 'service',
    vendorType: 'editors',
    rating: 4.8,
    reviewCount: 120,
    specialties: ['Chicago Manual', 'Copy Edit', 'Proofreading'],
    location: 'Remote',
    verified: true,
    profileUrl: '/services/editing/precision',
    startingPrice: '$0.015/word',
    bio: 'Meticulous copy editing and proofreading for fiction and non-fiction.',
    availabilityLabel: 'Available Now',
    joinedDate: '2023-05-12',
    willWorkOn: ['Fiction', 'Non-Fiction', 'Mystery', 'Thriller', 'Romance'],
    wontWorkOn: [],
    contentComfort: { maxSpice: 5, maxDarkness: 5 },
  },
  {
    id: 'edit-3',
    name: 'Story Crafters',
    image:
      'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    role: 'Editorial Services',
    variant: 'service',
    vendorType: 'editors',
    rating: 4.7,
    reviewCount: 45,
    specialties: ['Line Editing', 'Beta Reading', 'Critique'],
    location: 'Toronto, CA',
    verified: false,
    profileUrl: '/services/editing/story-crafters',
    startingPrice: '$0.01/word',
    bio: 'Affordable editing services for indie authors. Specializing in debut novels.',
    availabilityLabel: 'Open for Booking',
    joinedDate: '2023-10-01',
    willWorkOn: ['Romance', 'Young Adult', 'New Adult'],
    wontWorkOn: ['Horror', 'Dark Fantasy'],
    contentComfort: { maxSpice: 4, maxDarkness: 3 },
  },

  // Production
  {
    id: 'prod-1',
    name: 'Pristine Formatting',
    image:
      'https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    role: 'Formatter',
    variant: 'service',
    vendorType: 'production',
    rating: 4.8,
    reviewCount: 120,
    specialties: ['Vellum', 'InDesign', 'Ebook'],
    location: 'Remote',
    verified: true,
    profileUrl: '/services/production/pristine',
    startingPrice: '$150 flat',
    bio: 'Beautiful interior formatting for print and ebook. Fast turnaround.',
    availabilityLabel: 'Available Now',
    joinedDate: '2022-12-05',
    willWorkOn: ['Fiction', 'Non-Fiction', 'Romance', 'Fantasy'],
    wontWorkOn: [],
    contentComfort: { maxSpice: 5, maxDarkness: 5 },
  },
  {
    id: 'prod-2',
    name: 'Cover Artistry',
    image:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    role: 'Cover Designer',
    variant: 'service',
    vendorType: 'production',
    rating: 4.9,
    reviewCount: 200,
    specialties: ['Fantasy Covers', 'Typography', 'Illustration'],
    location: 'Berlin, DE',
    verified: true,
    profileUrl: '/services/production/cover-artistry',
    startingPrice: '$400',
    bio: 'Award-winning cover design for fantasy and sci-fi novels.',
    availabilityLabel: 'Booking 2024',
    joinedDate: '2023-02-28',
    willWorkOn: ['Fantasy', 'Sci-Fi', 'Epic Fantasy', 'Dark Fantasy'],
    wontWorkOn: ['Romance', 'Contemporary'],
    contentComfort: { maxSpice: 5, maxDarkness: 5 },
  },
  {
    id: 'prod-3',
    name: 'Audio Engineers',
    image:
      'https://images.unsplash.com/photo-1595152772835-219674b2a8a6?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    role: 'Audio Engineer',
    variant: 'service',
    vendorType: 'production',
    rating: 5.0,
    reviewCount: 60,
    specialties: ['Audiobook Mastering', 'Editing', 'Sound Design'],
    location: 'Nashville, TN',
    verified: true,
    profileUrl: '/services/production/audio-engineers',
    startingPrice: '$75 PFH',
    bio: 'Professional audio post-production for audiobooks. ACX standards guaranteed.',
    availabilityLabel: 'Open for Projects',
    joinedDate: '2023-09-15',
    willWorkOn: ['Audiobooks', 'Podcast'],
    wontWorkOn: [],
    contentComfort: { maxSpice: 5, maxDarkness: 5 },
  },

  // Support
  {
    id: 'supp-1',
    name: 'Novel Marketing',
    image:
      'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    role: 'Marketing Assistant',
    variant: 'service',
    vendorType: 'support',
    rating: 4.7,
    reviewCount: 60,
    specialties: ['Social Media', 'Newsletters', 'Ads'],
    location: 'Remote',
    verified: true,
    profileUrl: '/services/support/novel-marketing',
    startingPrice: '$30/hr',
    bio: 'Helping authors build their platform and sell more books through strategic marketing.',
    availabilityLabel: 'Waitlist',
    joinedDate: '2023-03-10',
    willWorkOn: ['Romance', 'Fantasy', 'Thriller'],
    wontWorkOn: [],
    contentComfort: { maxSpice: 5, maxDarkness: 5 },
  },
  {
    id: 'supp-2',
    name: 'Author PA Services',
    image:
      'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    role: 'Personal Assistant',
    variant: 'service',
    vendorType: 'support',
    rating: 4.9,
    reviewCount: 40,
    specialties: ['Admin', 'ARC Management', 'Scheduling'],
    location: 'Remote',
    verified: true,
    profileUrl: '/services/support/author-pa',
    startingPrice: '$25/hr',
    bio: 'Organized and efficient PA services for busy authors. Let me handle the admin while you write.',
    availabilityLabel: 'Limited Spots',
    joinedDate: '2023-06-20',
    willWorkOn: ['Romance', 'Mystery'],
    wontWorkOn: ['Dark Romance'],
    contentComfort: { maxSpice: 3, maxDarkness: 2 },
  },
  {
    id: 'supp-3',
    name: 'Book Launch Pros',
    image:
      'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    role: 'Launch Manager',
    variant: 'service',
    vendorType: 'support',
    rating: 4.8,
    reviewCount: 95,
    specialties: ['Launch Strategy', 'Street Teams', 'Promo'],
    location: 'Remote',
    verified: true,
    profileUrl: '/services/support/launch-pros',
    startingPrice: '$500/launch',
    bio: 'Comprehensive book launch management. We help you hit the bestseller lists.',
    availabilityLabel: 'Booking Nov',
    joinedDate: '2023-10-10',
    willWorkOn: ['All Genres'],
    wontWorkOn: [],
    contentComfort: { maxSpice: 5, maxDarkness: 5 },
  },

  // Creative
  {
    id: 'creat-1',
    name: 'Alex Morgan',
    image:
      'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    role: 'Cover Designer',
    variant: 'creative',
    vendorType: 'creative',
    rating: 5.0,
    reviewCount: 150,
    specialties: ['Fantasy Covers', 'Typography', 'Illustration'],
    location: 'London, UK',
    verified: true,
    profileUrl: '/creative/alex-morgan',
    startingPrice: '$500',
    bio: 'Award-winning cover designer specializing in high fantasy and sci-fi.',
    portfolioThumbnails: [
      'https://images.unsplash.com/photo-1614726365723-49cfae96a6b6?w=200',
      'https://images.unsplash.com/photo-1630328543239-16556c429748?w=200',
      'https://images.unsplash.com/photo-1618666012174-83b441c0bc76?w=200',
    ],
    availabilityLabel: 'Booking 2024',
    joinedDate: '2022-05-15',
    willWorkOn: [
      'Fantasy',
      'Sci-Fi',
      'Epic Fantasy',
      'Dark Fantasy',
      'Romantasy',
    ],
    wontWorkOn: ['Erotica'],
    contentComfort: { maxSpice: 4, maxDarkness: 4 },
  },
  {
    id: 'creat-2',
    name: 'Jordan Lee',
    image:
      'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    role: 'Character Artist',
    variant: 'creative',
    vendorType: 'creative',
    rating: 4.9,
    reviewCount: 95,
    specialties: ['Character Art', 'Digital Painting', 'Anime Style'],
    location: 'Toronto, CA',
    verified: false,
    profileUrl: '/creative/jordan-lee',
    startingPrice: '$150',
    bio: 'Bringing your characters to life with vibrant digital art.',
    portfolioThumbnails: [
      'https://images.unsplash.com/photo-1569173112611-52a7cd38bea9?w=200',
      'https://images.unsplash.com/photo-1580196969807-cc6de06c05be?w=200',
    ],
    availabilityLabel: 'Commissions Open',
    joinedDate: '2023-04-01',
    willWorkOn: ['Fantasy', 'Romance', 'Sci-Fi', 'Character Art'],
    wontWorkOn: [],
    contentComfort: { maxSpice: 5, maxDarkness: 5 },
  },
  {
    id: 'creat-3',
    name: 'Map Makers Guild',
    image:
      'https://images.unsplash.com/photo-1524638431109-93d95c968f03?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    role: 'Cartographer',
    variant: 'creative',
    vendorType: 'creative',
    rating: 4.8,
    reviewCount: 70,
    specialties: ['Fantasy Maps', 'World Building', 'Illustration'],
    location: 'Dublin, IE',
    verified: true,
    profileUrl: '/creative/map-makers',
    startingPrice: '$200',
    bio: 'Detailed fantasy maps for your novels interior. Custom styles available.',
    portfolioThumbnails: [
      'https://images.unsplash.com/photo-1524661135-423995f22d0b?w=200',
      'https://images.unsplash.com/photo-1577083552431-6e5fd01aa342?w=200',
    ],
    availabilityLabel: 'Open for Commissions',
    joinedDate: '2023-10-12',
    willWorkOn: ['Fantasy', 'Epic Fantasy', 'Historical Fiction'],
    wontWorkOn: [],
    contentComfort: { maxSpice: 5, maxDarkness: 5 },
  },
]
